import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, AlertTriangle, Loader2, Undo2 } from 'lucide-react';
import { Button } from '../../ui/button';

const slug = (t) => t.toLowerCase().normalize('NFD').replace(/[^a-z0-9]+/g, '-');

const Attivita = ({ a }) => (
  <li className="py-2 border-b border-gray-200 last:border-0">
    <div className="flex items-start justify-between gap-3">
      <span className="text-sm text-gray-800">{a.attivita}</span>
      <span className="shrink-0 text-[11px] font-medium text-gray-500">{a.frequenza_label}</span>
    </div>
    <p className="text-xs text-gray-500 mt-0.5">
      {a.tipo_label}{a.prodotti?.length ? `: ${a.prodotti.join(', ')}` : ''}
    </p>
    {a.ritardo > 0 && (
      <p className="text-xs font-semibold text-amber-600 mt-0.5">In ritardo di {a.ritardo} {a.ritardo === 1 ? 'giorno' : 'giorni'}</p>
    )}
  </li>
);

const Registrazione = ({ r, onAnnulla }) => (
  <div className="flex items-center justify-between gap-2 text-sm" data-testid={`pulizie-reg-${r.id}`}>
    <span className={r.esito === 'problema' ? 'text-amber-600 font-medium' : 'text-emerald-600 font-medium'}>
      {r.esito === 'problema' ? 'Problema segnalato' : 'Fatto'} da {r.operatore} alle {r.ora}
    </span>
    {r.mia && (
      <button onClick={() => onAnnulla(r)} className="flex items-center gap-1 text-xs text-gray-500 hover:text-gray-800"
        data-testid={`pulizie-annulla-${r.id}`}>
        <Undo2 className="h-3.5 w-3.5" /> Annulla
      </button>
    )}
  </div>
);

export const ZonaCard = ({ zona, onFatto, onProblema, onAnnulla }) => {
  const [aperta, setAperta] = useState(false);
  const [busy, setBusy] = useState(false);
  const daFare = zona.dovute.length;
  const id = slug(zona.zona);
  const fatto = async () => { setBusy(true); await onFatto(zona.zona); setBusy(false); };

  return (
    <div data-testid={`pulizie-zona-${id}`}
      className={`bg-white rounded-2xl border p-4 transition-colors ${daFare ? 'border-gray-200' : 'border-emerald-400/60'}`}>
      <button onClick={() => setAperta((v) => !v)} className="w-full flex items-center gap-3 text-left"
        data-testid={`pulizie-zona-toggle-${id}`}>
        {daFare ? <span className="h-7 w-7 rounded-full border-2 border-gray-300 shrink-0" />
          : <CheckCircle2 className="h-7 w-7 text-emerald-500 shrink-0" />}
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-900">{zona.zona}</h3>
          <p className="text-xs text-gray-500">{daFare ? `${daFare} ${daFare === 1 ? 'cosa' : 'cose'} da fare` : 'Tutto fatto'}</p>
        </div>
        {daFare > 0 && <ChevronDown className={`h-5 w-5 text-gray-400 transition-transform ${aperta ? 'rotate-180' : ''}`} />}
      </button>

      {aperta && daFare > 0 && <ul className="mt-3 pl-10" data-testid={`pulizie-zona-attivita-${id}`}>{zona.dovute.map((a) => <Attivita key={a.id} a={a} />)}</ul>}

      {zona.registrazioni.length > 0 && (
        <div className="mt-3 pl-10 space-y-1">{zona.registrazioni.map((r) => <Registrazione key={r.id} r={r} onAnnulla={onAnnulla} />)}</div>
      )}

      {daFare > 0 && (
        <div className="mt-4 flex gap-2">
          <Button onClick={fatto} disabled={busy} data-testid={`pulizie-fatto-${id}`}
            className="flex-1 h-12 text-base bg-emerald-600 hover:bg-emerald-700 text-white">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <><CheckCircle2 className="h-5 w-5 mr-2" />Fatto</>}
          </Button>
          <Button variant="outline" onClick={() => onProblema(zona.zona)} data-testid={`pulizie-problema-${id}`} aria-label="Segnala problema"
            className="h-12 border-amber-400 text-amber-700 hover:bg-amber-50">
            <AlertTriangle className="h-4 w-4 sm:mr-2" /><span className="hidden sm:inline">Problema</span>
          </Button>
        </div>
      )}
    </div>
  );
};
